import { render, staticRenderFns } from "./StatusDaAdesao.vue?vue&type=template&id=029c426e&"
import script from "./StatusDaAdesao.vue?vue&type=script&lang=js&"
export * from "./StatusDaAdesao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports